import Spacer_icon from "../icons/spacer_icon";
import React from 'react'

const { registerBlockType, registerBlocksStyle } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    AlignmentToolbar, 
    BlockAlignmentToolbar,
    RichText,
    MediaUpload, MediaUploadCheck, InnerBlocks } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, SelectControl, RangeControl, Dashicon, ToggleControl, ColorPalette, ColorIndicator,
    Card, CardBody, Button, AlignmentMatrixControl, AnglePickerControl, ColorGradientControl, __experimentalGradientPicker, ColorPicker } = wp.components;




registerBlockType('blocksbakery/spacer', {
    title: __('Spacer', 'blocks-bakery'),
    description: __(
        'This block is Adding Space Between the Elements',
        'blocks-bakery'
    ),

    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: Spacer_icon.Spacer,
    keywords: [
        __('Spacer', 'blocks-bakery'),
        __('Padding', 'blocks-bakery'),
        __('Height', 'blocks-bakery'),
    ],
    supports: {
        html: false
    },
    "attributes": {
		"spacer_height": {
			"type": "number",
			"default": "10"
		},
		"spacer_height_units": {
			"type": "string",
			"default": "px"
		},
		"units_control": {
			"type": "number",
			"default": "600"
		},
        "bb_spacer_wrapper": {
            "source": "attribute",
            "attribute": "style"
        },
        "bb_spacer_inner": {
            "source": "attribute",
            "attribute": "style"
        },
        "bg_color":{
            "type":"string",
            "default":"#eee",
        }
	},

   

  
    edit: (props) => {

        let styles = {

            bb_spacer_wrapper:{
                backgroundColor:props.attributes.bg_color
            },
            bb_spacer_inner: {
              height:props.attributes.spacer_height+props.attributes.spacer_height_units,
          
            },

        }
        const px_height = () => {
            var px_height = document.querySelector('.px_height');
            var vh_height = document.querySelector('.vh_height');
            var em_height = document.querySelector('.em_height');
            px_height.style.textDecoration="underline";
            vh_height.style.textDecoration="none";
            em_height.style.textDecoration="none";
            props.setAttributes({spacer_height_units:'px'})
            props.setAttributes({units_control:600})
        }
        const vh_height = () => {
            var px_height = document.querySelector('.px_height');
            var vh_height = document.querySelector('.vh_height');
            var em_height = document.querySelector('.em_height');
            px_height.style.textDecoration="none";
            vh_height.style.textDecoration="underline";
            em_height.style.textDecoration="none";
            props.setAttributes({spacer_height_units:'vh'})
            props.setAttributes({units_control:100})
        }
        const em_height = () => {
            var px_height = document.querySelector('.px_height');
            var vh_height = document.querySelector('.vh_height');
            var em_height = document.querySelector('.em_height');
            px_height.style.textDecoration="none";
            vh_height.style.textDecoration="none";
            em_height.style.textDecoration="underline";
            props.setAttributes({spacer_height_units:'em'})
            props.setAttributes({units_control:20})
        }

       

        //For Responsive Design

        
        const laptop = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
        }
        const tablet = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
        }
        const smartphone = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
        }
        
       
        
        return [

            <React.Fragment>
                 <InspectorControls>
            <PanelBody title={__("Spacer")} initialOpen={false}>
            <PanelRow>
                      
                            <div>
                                <span style={{marginRight:10}}>Height</span>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>

                            <div>
                                <Button className="px_height" onClick={px_height} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button className="vh_height" onClick={vh_height} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vh</Button>
                                <Button className="em_height" onClick={em_height} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                              </div>
            
                         

                        </PanelRow>

                        <RangeControl
                       
                       min={0}
                       max={props.attributes.units_control}
                       initialPosition={10}
                       value={props.attributes.spacer_height}
                       onChange={(new_val) => {
                           props.setAttributes({ spacer_height: new_val })
                       }}

                   />
            </PanelBody>
        </InspectorControls>
           <div className="bb-spacer-container" style={styles.bb_spacer_wrapper}>
               <div className="bb-spacer-inner" style={styles.bb_spacer_inner}></div>

           </div>
            </React.Fragment>
        ]
    },

    save: (props) => {
        return (null)
    }
});


